<template>
  <div class="BulkInscription">
    <div class="titlePage">Importación de archivo Inscripciónes masivas</div>

    <span class="ml-3">Seleccionar archivo de inscripción masiva</span>
    <div>
      <Formulario
        :FieldsForm="Formulario.fields1"
        :ModelForm="formInsModel"
        :method="executeProcess"
      />
      <div id="div_Respuesta"></div>
      <span class="ml-3">
        <a
          class="text-info"
          href="https://services.ibero.edu.co/Files/ManualCargueMasivo.pdf"
          target="_blank"
        >Necesita ayuda haga click aqui</a>
      </span>
    </div>
  </div>
</template>

<script>
import Formulario from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'BulkInscription',
  components: {
    Formulario,
  },
  data () {
    return {
      labelFields: {
        fields1: 'Importación de archivo',
      },
      Formulario: {
        fields1: [
          {
            id: 'IdFile',
            placeholder: 'Examinar',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-9',
          },
          {
            id: 'IdProcessFile',
            type: 'button',
            placeholder: 'Procesar Inscripciones',
            class: 'col-md-3',
          },
          {
            id: 'IdTextFind',
            model: 'IdTextFind',
            type: 'html',
            values: '',
            class: 'col-md-12',
          },
        ],
      },
      formUserFileModel: [],
    }
  },
  created () {},
  methods: {
    valdate (infoDat) {
      return IberoHelpers.dataObjDate(infoDat)
    },
    executeProcess: function (event) {
      switch (event.target.id) {
        case 'IdFile':
          document.getElementById('div_Respuesta').innerHTML = ''
          this.formUserFileModel = []
          if (
            event.target.files[0].name
              .split('.')
              .pop()
              .indexOf('xls') === 0
          ) {
            event.target.nextElementSibling.innerText =
              event.target.files[0].name
            this.formUserFileModel.push({ filedata: event.target.files[0] })
          } else {
            alert('El archivo cargado no es valido.')
          }
          break
        case 'btn_IdProcessFile':
          if (this.formUserFileModel.length > 0) {
            var dataFile = IberoHelpers.sendUpdloadFile(
              this.$store,
              this.formUserFileModel,
              'BULKINSCRIPTION',
              0
            )
            document.getElementById('IdFile').nextElementSibling.innerText =
              'Procesando.....'
            document.getElementById('btn_IdProcessFile').style.display = 'none'
            dataFile.then(Response => {
              if (
                Response !== false &&
                Response[0].wsDocument.data.id_File !== undefined
              ) {
                dataFile = IberoHelpers.processBulkInscription(
                  this.$store,
                  JSON.parse(Response[0].wsDocument.data.id_File)[0]
                )
                dataFile.then(Response => {
                  if (Response !== false) {
                    this.formUserFileModel = []
                    var sTable =
                      "<div class='alert alert-success' role='alert'>" +
                      'Resultado.' +
                      '</div> '
                    if (Response.data.message !== '') {
                      sTable =
                        "<table class='table table-hover' id='myTable2' ref='table'>" +
                        '       <thead>' +
                        '         <tr>' +
                        "           <th scope='col'>Respuesta</th>" +
                        '         </tr>' +
                        '       </thead>' +
                        '       <tbody> '

                      try {
                        for (
                          var i = 0;
                          i < JSON.parse(Response.data.message).length;
                          i++
                        ) {
                          sTable +=
                            '<tr> <td>' +
                            JSON.parse(Response.data.message)[i].Message +
                            '</td></tr>'
                        }
                      } catch (error) {
                        sTable +=
                          '<tr> <td>' + Response.data.message + '</td></tr>'
                      }
                      sTable += '</tbody> </table>'
                    }
                  } else {
                    alert(
                      'No es posible procesar el archivo error de conexión !!!'
                    )
                  }
                  document.getElementById('div_Respuesta').innerHTML = sTable
                  document.getElementById('btn_IdProcessFile').style.display =
                    ''
                  document.getElementById(
                    'IdFile'
                  ).nextElementSibling.innerText = ''
                })
              } else {
                alert(
                  'No es posible cargar el archivo al sistema error de conexión !!!'
                )
                document.getElementById('btn_IdProcessFile').style.display = ''
                document.getElementById('IdFile').nextElementSibling.innerText =
                  ''
              }
            })
          } else {
            alert('No ha cargado ningun archivo para procesar.')
          }
          break
      }
    },
  },
}
</script>